import { useTranslation } from 'react-i18next';

import { PartyDTO } from 'support/types';

import { Party } from '../components/Party';

enum PartyType {
  Billing = 'billing',
  Delivery = 'delivery',
}

type DeliveryPartyProps = {
  selectedPartyId?: string;
  onSelectParty: (partyId: string) => void;
  parties: Array<PartyDTO> | undefined;
  onAddParty: (party: PartyDTO, onSuccess?: () => void) => void;
  onEditParty: (party: PartyDTO, onSuccess?: () => void) => void;
  disabled: boolean;
  error: string | null;
  clearError: () => void;
  isLoading: boolean;
};

export function DeliveryParty({
  parties,
  selectedPartyId,
  onSelectParty,
  onAddParty,
  onEditParty,
  disabled,
  error,
  clearError,
  isLoading,
}: DeliveryPartyProps) {
  const { t } = useTranslation();

  return (
    <>
      <p className="text-base leading-6 font-bold text-gray-900">{t('orderForms:checkout.deliveryAddress')}</p>
      <Party
        selectedPartyId={selectedPartyId}
        parties={parties || []}
        partyType={PartyType.Delivery}
        onSelectParty={onSelectParty}
        onAddParty={onAddParty}
        onEditParty={onEditParty}
        disabled={disabled}
        error={error}
        clearError={clearError}
        isLoading={isLoading}
      />
    </>
  );
}
